// extracted by mini-css-extract-plugin
module.exports = {"label":"_93444fe79c--label--259i1"};